export default __webpack_public_path__ + "static/404-173a5cb8cc57cc7f633ceed423f30012.svg";